import React, { useState } from 'react';
import './ShareCardStep.css';

interface ShareCardStepProps {
  companyName: string;
  roleTitle: string;
  onDone: () => void;
}

export function ShareCardStep({ companyName, roleTitle, onDone }: ShareCardStepProps) {
  const [copied, setCopied] = useState(false);

  const shareMessage = `I got hired at ${companyName} through ReffConnect 🎉\nRole: ${roleTitle}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareMessage);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API may be blocked; silently ignore
    }
  };

  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=https://reffconnect.com&summary=${encodeURIComponent(shareMessage)}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`;

  return (
    <div className="share-card" aria-labelledby="share-card-title">
      <div className="hired-modal__scroll">
        <div className="hired-modal__head">
          <div>
            <span className="hired-modal__eyebrow">Celebrate your win 🎊</span>
            <h2 id="share-card-title" className="hired-modal__title">
              Share your achievement
            </h2>
          </div>
        </div>

        <div className="share-card__message-box" aria-label="Share message preview">
          <p className="share-card__message">{shareMessage}</p>
        </div>

        <div className="share-card__actions">
          <button
            type="button"
            className="share-card__btn share-card__btn--copy"
            onClick={handleCopy}
            aria-label={copied ? 'Copied!' : 'Copy share message'}
          >
            {copied ? '✓ Copied!' : '📋 Copy'}
          </button>

          <a
            href={linkedInUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-card__btn share-card__btn--linkedin"
            aria-label="Share on LinkedIn"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M6.94 8.5h3.2V19H6.94V8.5Zm1.6-5.5a1.86 1.86 0 1 1 0 3.72 1.86 1.86 0 0 1 0-3.72Zm3.58 5.5h3.06v1.43h.04c.43-.81 1.47-1.67 3.03-1.67 3.23 0 3.83 2.13 3.83 4.9V19h-3.2v-5.2c0-1.24-.02-2.83-1.72-2.83-1.73 0-2 1.35-2 2.74V19h-3.2V8.5Z" />
            </svg>
            LinkedIn
          </a>

          <a
            href={twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-card__btn share-card__btn--twitter"
            aria-label="Share on X (Twitter)"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
            </svg>
            X (Twitter)
          </a>
        </div>
      </div>

      <div className="hired-modal__actions hired-modal__actions--single">
        <button
          type="button"
          className="hired-modal__btn hired-modal__btn--primary"
          onClick={onDone}
        >
          Done
          <span className="hired-modal__btn-shine" aria-hidden />
        </button>
      </div>
    </div>
  );
}
